// Remembered-device tokens, one per email so merchants sharing a browser don't overwrite each other.
// Kept outside redux so logging out doesn't forget the device.
const STORAGE_KEY = 'trustedDevices';

function readAll() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
  } catch (err) {
    return {};
  }
}

export function getDeviceToken(email) {
  return readAll()[email];
}

export function saveDeviceToken(email, token) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...readAll(), [email]: token }));
  } catch (err) {
    // Private mode or storage full. The merchant just gets asked for a code next time.
  }
}
